import { Component, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { NavigationEnd, NavigationError, Router } from '@angular/router';
import { filter } from 'rxjs';
import { UrlService } from '../core/services/url.service';
import * as moment from 'moment/moment';

const CHUNK_RELOAD_KEY = 'acan.chunkReload';
const CHUNK_RELOAD_WINDOW_MS = 10000;
const CHUNK_ERROR_PATTERN =
  /ChunkLoadError|Loading chunk [\w-]+ failed|Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  previousUrl = '';
  currentUrl = '';

  constructor(
    private primengConfig: PrimeNGConfig,
    private router: Router,
    private urlService: UrlService
  ) {}

  ngOnInit() {
    this.primengConfig.ripple = true;
    // IMP-01: enable +1 type scale by default; set localStorage 'acan.typeScalePlus' = '0' to disable.
    try {
      const stored = localStorage.getItem('acan.typeScalePlus');
      const enabled = stored !== '0';
      document.documentElement.classList.toggle('pp-type-scale-plus', enabled);
    } catch {
      document.documentElement.classList.add('pp-type-scale-plus');
    }
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        this.urlService.setPreviousUrl(this.previousUrl);
      });
    this.router.events
      .pipe(filter((event): event is NavigationError => event instanceof NavigationError))
      .subscribe(event => this.recoverFromNavigationError(event));
    moment.updateLocale(moment.locale(), {
      week: {
        dow: 1, // Set the first day of the week as Monday
      },
    });
  }

  /**
   * A lazy route whose chunk can't be fetched (new deploy replaced the hashed
   * files, or the dev server restarted) fails silently and the click looks
   * dead. Reload straight into the target URL so the fresh bundle is used.
   */
  private recoverFromNavigationError(event: NavigationError): void {
    const err = event.error;
    const message = `${err?.name || ''} ${err?.message || err || ''}`;
    if (!CHUNK_ERROR_PATTERN.test(message)) {
      console.error('Navigation failed', event.url, err);
      return;
    }
    try {
      const last = JSON.parse(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 'null');
      if (last?.url === event.url && Date.now() - last.at < CHUNK_RELOAD_WINDOW_MS) {
        console.error('Navigation failed after reload', event.url, err);
        return;
      }
      sessionStorage.setItem(
        CHUNK_RELOAD_KEY,
        JSON.stringify({ url: event.url, at: Date.now() })
      );
    } catch {
      // storage unavailable: still attempt one reload
    }
    window.location.assign(event.url);
  }
}
